export default [
  {
    path: '/backend/stream',
    name: 'backend.stream',
    component: () => import(/* webpackChunkName: "Stream" */ './CreateCustomItem')
  }
]
